import React from 'react'
import { HStack, VStack, Box, Image, Text, Button } from '@chakra-ui/react';
import b1 from '../img/book13/13-1.jpg';
import b2 from '../img/book13/13-2.jpg';
import b3 from '../img/book13/13-3.jpg';
import b4 from '../img/book13/13-4.jpg';
import b5 from '../img/book13/13-5.jpg';
import b6 from '../img/book13/13-6.jpg';
import b7 from '../img/book13/13-7.jpg';
import b8 from '../img/book13/13-8.jpg';
import b9 from '../img/book13/13-9.jpg';
import b10 from '../img/book13/13-10.jpg';
import b11 from '../img/book13/13-11.jpg';
import b12 from '../img/book13/13-12.jpg';
const Books13 = () => {
  return (
    <>
    <VStack spacing={4} align="stretch" alignItems={'center'} mt={4}>
      {/* ---------------------book1--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            borderColor="lightgray"
            bg={'#fff'}
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b1} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    الخيال الدرامي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    حلا مايا
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    روبيرت جونز
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b2} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    الخيال العلمي والفلسفة
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    أحمد الهواري
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    سوزان شنايدر
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            bg={'#fff'}
            borderRadius="10px"
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b3} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    مسرح اللا إبهار
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    ربى الجامع
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    جوردان تناهيل
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book2--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b4} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    فرسان وكهنة: قطز
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    تيموثي غريغوري
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                        
                    منذر القباني
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار: &nbsp;
                    <span>
                    يتخيلون
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b5} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان: &nbsp;
                    <span>  
                    فرسان وكهنة: غريب
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    الاسبانية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    أرتورو بيلايو
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    منذر القباني
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b6} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    يقطينيا
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    الاسبانية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    أرتورو بيلايو
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    ياسر بهجت
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book3--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b7} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    بطاقات جامحة
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    ياسر بهجت
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    جورج مارتن
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b8} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    اجتهاد الممثل
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الروسية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    محمد هشام فؤاد
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    قسطنطين ستانسلافسكي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    يتخيلون
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b9} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    الكثيب فلسفياً
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    ربى خدام الجامع
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    جيفري نيكولاس
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    يتخيلون
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book4--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b10} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    عالم مارفل كوميكس
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    باسم آمون
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    آندرو جاي فريدينثال
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b11} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    كريستوفر نولان
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    إيناس حلمي عبدالحميد
                          </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    مارك ت. كونارد
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    يتخيلون
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b12} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    فنون وحِرف الحضارة الإسلامية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    حمد السعدنى
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    خالد عزام
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    يتخيلون
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: L5 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
    </VStack>
  </>
  )
}

export default Books13